import React, { Component } from "react";
import { AppContext } from "../../utils/context";
import {
  Form,
  Container,
  Confirm,
  Button
} from "semantic-ui-react";
import set from "lodash/set";

import request from "../../utils/request";
import ResponseMessage from "../../components/common/ResponseMessage";

const deviceProfile = () => {
  return {
    id: 0,
    name: "",
    ipad_uid: "",
    active: 0,
    is_new: 0,
    accept_credit: 0,
    accept_cash: 0,
    deleted_at: null
  };
};
const resetState = () => {
  return {
    isMounted: false,
    loading: true,
    xhrStatus: "",
    xhrMessage: "",
    deviceId: 0,
    profile: deviceProfile(),
    confirmOpen: false,
    confirmId: 0,
    confirmTitle: ""
  };
};

class DeviceProfile extends Component {
  constructor(props) {
    super(props);
    this.state = resetState();

    let id = this.props.match.params.id ? this.props.match.params.id : 0;
    this.state.deviceId = id;

    this.handleChange = this.handleChange.bind(this);
    this.fetchData = this.fetchData.bind(this);
  }
  componentDidMount = async () => {
    if (this.props.match.params.id === ":id") {
      this.props.history.replace('/devices');
      return;
    }

    this.setState({ isMounted: true });

    this.fetchData();
  };
  componentWillUnmount = () => {
    this.setState(resetState());
  };
  fetchData = () => {
    let self = this;
    let promises = [];
    if (this.state.deviceId > 0) {
      promises.push(request.get(this, `api:/device/${this.state.deviceId}?ts=${Date.now()}`));
    }
    if (promises.length > 0) {
      Promise.all(promises).then(function (values) {
        if (values[0]) {
          self.setProfile(values[0]);
        }
        self.setState({ loading: false });
      });
    } else {
      this.setState({ loading: false });
    }
  };
  handleChange = (e, { name, value }) => {
    let data = { ...this.state.profile };
    if (name === "active" && +data.active === 1) {
      value = 0;
    }
    if (name === "accept_credit" && +data.accept_credit === 1) {
      value = 0;
    }
    if (name === "accept_cash" && +data.accept_cash === 1) {
      value = 0;
    }
    if (name === "accept_debit" && +data.accept_debit === 1) {
      value = 0;
    }
    set(data, name, value);
    this.setState({ profile: data });
  };
  setProfile = result => {
    let profile = result;
    this.setState({
      profile: profile,
      loading: false
    });
  };
  handleSubmit = () => {
    this.setState({
      loading: true,
      xhrStatus: "",
      xhrMessage: ""
    });
    let req;
    const { profile } = this.state;

    if (!this.context.config.cc_enabled) {
      profile.accept_cash = 1;
    }

    if (profile.id > 0) {
      req = request.put(this, `api:/device/${profile.id}`, profile);
    } else {
      req = request.post(this, "api:/device", profile);
    }

    req.then(resp => {
      this.setState({
        xhrStatus: resp.success ? "success" : "error",
        xhrMessage: resp.message,
        loading: false
      });
      if (resp.success) {
        if (this.state.deviceId === 0) this.setState({ profile: deviceProfile() });
        setTimeout(() => this.setState({ xhrStatus: '', xhrMessage: '' }), 4000);
      }
    });
  };
  showConfirm = (id, title) => {
    this.setState({ confirmOpen: true, confirmId: id, confirmTitle: title });
  };
  handleConfirm = () => {
    if (this.state.profile.deleted_at == null) {
      this.deleteDevice();
    } else {
      this.restoreDevice();
    }
  };
  handleCancel = () => {
    this.setState({
      result: "cancelled",
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
  };
  deleteDevice = () => {
    let payload = { id: this.state.confirmId };
    this.setState({
      loading: true,
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
    return request.delete(this, `api:/device/${this.state.confirmId}`, payload).then(resp => {
      this.setState({
        xhrStatus: resp.success ? "success" : "error",
        xhrMessage: resp.message,
        loading: false
      });
      return this.fetchData();
    });
  };
  restoreDevice = () => {
    let payload = { device_id: this.state.confirmId };
    this.setState({
      loading: true,
      confirmOpen: false,
      confirmId: 0,
      confirmTitle: ""
    });
    return request.post(this, `api:/device/restore`, payload).then(resp => {
      this.setState({
        xhrStatus: resp.success ? "success" : "error",
        xhrMessage: resp.message,
        loading: false
      });
      return this.fetchData();
    });
  };
  handleDismissPortal = () => {
    if (this.state.xhrStatus === '') return null;
    this.setState({ xhrStatus: '', xhrMessage: '' });
  }
  render() {
    const {
      loading,
      xhrStatus,
      xhrMessage,
      profile,
      confirmOpen,
      confirmTitle
    } = this.state;

    return (
      <Container text>
        <Confirm
          open={confirmOpen}
          content={confirmTitle}
          cancelButton="Cancel"
          confirmButton="Confirm"
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
        <Form
          id="deviceForm"
          loading={loading}
          success={xhrStatus === "success"}
          error={xhrStatus === "error"}
          onBlur={this.handleDismissPortal}
        >
          <Form.Input
            name="name"
            label="Device Name"
            placeholder="Device Name"
            value={profile.name || ""}
            onChange={this.handleChange}
            required
          />
          <Form.Input
            name="ipad_uid"
            label="Device ID"
            placeholder="Device ID"
            value={profile.ipad_uid || ""}
            onChange={this.handleChange}
            required
          />
          <Form.Radio
            name="active"
            toggle
            label={+profile.active === 1 ? "Active" : "Inactive"}
            value="1"
            checked={+profile.active === 1 ? true : false}
            onChange={this.handleChange}
          />
          <Form.Radio
            name="accept_cash"
            toggle
            label={
              +profile.accept_cash === 1 || !this.context.config.cc_enabled
                ? "Accept cash"
                : "Cannot accept cash"
            }
            value="1"
            disabled={!this.context.config.cc_enabled}
            checked={+profile.accept_cash === 1 || !this.context.config.cc_enabled ? true : false}
            onChange={this.handleChange}
          />
          {this.context.config.cc_enabled && <Form.Radio
            name="accept_credit"
            toggle
            label={
              +profile.accept_credit === 1
                ? "Accept credit cards"
                : "Cannot accept credit cards"
            }
            value="1"
            checked={+profile.accept_credit === 1 ? true : false}
            onChange={this.handleChange}
          />}
          {this.context.config.debit_enabled && this.context.config.app_payments === "shift4" && <Form.Radio
            name="accept_debit"
            toggle
            label={
              +profile.accept_debit === 1
                ? "Accept debit cards"
                : "Cannot accept debit cards"
            }
            value="1"
            checked={+profile.accept_debit === 1 ? true : false}
            onChange={this.handleChange}
          />}
          <Button
            primary
            floated="right"
            icon="save"
            content="Save"
            onClick={this.handleSubmit}
            disabled={!profile.accept_cash && !profile.accept_credit && this.context.config.cc_enabled}
          />
          {+profile.id > 0 && <Button
            color={profile.deleted_at == null ? "red" : "green"}
            floated="right"
            onClick={() =>
              this.showConfirm(
                profile.id,
                "Are you sure you want to " + (profile.deleted_at == null ? "delete " : "restore ") + profile.name + "?"
              )
            }
            icon={profile.deleted_at == null ? "trash" : "undo"}
            content={profile.deleted_at == null ? "Delete" : "Restore"}
          />}
          <ResponseMessage status={xhrStatus} message={xhrMessage} />
        </Form>
      </Container>
    );
  }
}

DeviceProfile.contextType = AppContext;

export default DeviceProfile;
